import { baseObjectSchema } from '../baseSchemas';
import { z } from 'zod';

export const rangeItems = baseObjectSchema.extend({
  rangeId: z.string(),
  materialId: z.string(),
  materialAlterCodeId: z.string(),
  quantity: z.number().optional(),
  materialAlterCode: z
    .object({
      id: z.string(),
      alterCode: z
        .object({
          name: z.string(),
          code: z.string(),
          id: z.string(),
        })
        .optional(),
    })
    .optional(),
});

export const getRangeItemsSchema = z.array(rangeItems);

export type GetRangeItemsResponse = z.infer<typeof getRangeItemsSchema>;
